import { useState, useEffect } from "react";
export const useActivateTooltip = (elementRef) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const compareWidth = () => {
        const compare = !!elementRef.current?.scrollWidth &&
            !!elementRef.current?.clientWidth &&
            elementRef.current.scrollWidth > elementRef.current.clientWidth;
        setShowTooltip(compare);
    };
    useEffect(() => {
        compareWidth();
        window.addEventListener("resize", compareWidth);
        return () => window.removeEventListener("resize", compareWidth);
    }, []);
    return showTooltip;
};
